import { CellInfo } from 'react-table-6';
import { IDs } from '../../../helpers/IDs';
import * as React from 'react';
import { WTable } from '../../../core/table/WTable';

interface KennzahlenRohExportProps extends React.ClassAttributes<any> {
    data: any;
}

interface KennzahlenRohExportState {
    columns: any[];
    data: any[];
    gewerk: number;
}

export class KennzahlenRohExport extends React.Component<KennzahlenRohExportProps, KennzahlenRohExportState> {

    constructor(props: any) {
        super(props);
        this.state = {
            columns: [],
            data: [],
            gewerk: undefined
        };
        this.init = this.init.bind(this);
        this.setColumns = this.setColumns.bind(this);
        this.setData = this.setData.bind(this);
    }

    private columns: any = {};
    private data: any = {};
    private gewerke: any[] = [];
    private format: any[] = [
        new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
        new Intl.NumberFormat('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }),
        new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    ];
    private config: any = {
        // [Bezeichnung, Format?, Breite?]
        lfd: ['Lfd', null, 40],
        gewerk: ['Gewerk', null, 80],
        betrieb: ['Betrieb', null, 60],
        jahr: ['Jahr', null, 40],
        filialen: ['Anzahl der Filialen', 0],
        mitarbeiter: ['Mitarbeitende (Vollzeitäquivalent)', 0],
        umsatz: ['Umsatz [€]', 2],
        flaeche: ['Beheizte Gebäudefläche [m²]', 0],
        eigenstom_nutzung: ['Eigenstromnutzung [ja/nein]'],
        eigenstrom_verbrauch: ['Eigenstromverbrauch [kWh/a]', 0],
        strom_verbrauch_fremdbezug: ['Strom: Jahresverbrauch Fremdbezug [kWh/a]', 0],
        strom_verbrauch_gesamt: ['Strom: Jahresverbrauch gesamt [kWh/a]', 0],
        strom_kosten_gesamt: ['Strom: Gesamtkosten (netto) [€/a]', 2],
        strom_heizen_elektrisch: ['Heizen mit elektrischer Energie [ja/nein]'],
        strom_verbrauch_heizen_elektrisch: ['Jahresstromverbrauch elektrische Heizung [kWh/a]', 0],
        kosten_heizen_elektrisch: ['Kosten elektrische Heizung (netto) [€/a]', 2],
        gas_verbrauch_m3: ['Erdgas: Jahresverbrauch [m³/a]', 0],
        gas_verbrauch_kwh: ['Erdgas: Jahresverbrauch [kWh/a]', 0],
        gas_kosten: ['Erdgas: Kosten (netto) [€/a]', 2],
        oel_verbrauch_l: ['Öl: Jahresverbrauch [l/a]', 0],
        oel_verbrauch_kwh: ['Öl: Jahresverbrauch [kWh/a]', 0],
        oel_kosten: ['Öl: Kosten (netto) [€/a]', 2],
        fw_verbrauch: ['Fernwärme: Jahresverbrauch [kWh/a]', 0],
        fw_kosten: ['Fernwärme: Kosten (netto) [€/a]', 2],
        andere_verbrauch_kwh: ['Sonstige Energieträger: Jahresverbrauch [kWh/a]', 0],
        andere_kosten: ['Sonstige Energieträger: Kosten (netto) [€/a]', 2],
        eigenwaerme_nutzung: ['Eigenwärmenutzung [ja/nein]'],
        benzin_verbrauch: ['Benzin: Jahresverbrauch [l/a]', 0],
        diesel_verbrauch: ['Diesel: Jahresverbrauch [l/a]', 0],
        kraftstoffe_kosten: ['Kraftstoffe: Jahresgesamtkosten (netto) [€/a]', 2],
        wasser_verbrauch_tag: ['Wasser: Tagesverbrauch [l/Tag]', 0],
        wasser_verbrauch_jahr: ['Kraftstoffe: Jahresgesamtkosten (netto) [€/a]', 2],
        wasser_kosten: ['Wasser: Jahresgesamtkosten (netto) [€]', 2],
        mehl_verbrauch: ['Mehl: Jahresverbrauch [kg/a]', 0], // Bäcker
        fleisch_verbrauch: ['Fleischverbrauch [t/a]', 0], // Fleischer
        back_flaeche: ['Backfläche [m²]', 0], // Bäcker
        prod_flaeche: ['Produktionsfläche [m²]', 0], // Fleischer
        co2_emission: ['CO2-Emission [t/a]', 0],
        energiekosten_umsatz: ['Energiekosten / Umsatz [%]', 1],
        strom_ma: ['Stromverbrauch/Mitarbeitende:r[kWh/MA*a]', 0],
        waerme_ma: ['Wärmemenge/Mitarbeitende:r[kWh/MA*a]', 0],
        energieverbrauch_ma: ['Gesamtenergieeinsatz/Mitarbeitende:r[kWh/MA*a]', 0],
        energiekosten_ma: ['Energiekosten/Mitarbeitende:r[€]', 2],
        energie_mehl: ['Energieeinsatz / Mehlverbrauch [kWh/kg*a]', 0], // Bäcker
        energie_back_flaeche: ['Energieeinsatz / Backfläche [MWh/m²*a]', 0], // Bäcker
        energie_gebaeude_flaeche: ['Energieeinsatz / beheizte Gebäudefläche [kWh/m²*a]', 0] // Friseure, Kfz, Tischler
    };

    componentDidMount(): void {
        this.init();
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        if (this.state.gewerk !== prevState.gewerk) {
            this.setColumns();
        }
    }

    getCellInfo(name: string): any {
        return (row: CellInfo, isExport?: boolean) => {
            const format: number = typeof (this.config[name] || [])[1] === 'number'
                ? this.config[name][1]
                : null;
            const value: number | string = row.value;
            const isNumber: boolean = !!(format !== null && this.format[format]);
            const valueFormat: string = isNumber && typeof value === 'number'
                ? this.format[format].format(value)
                : value;

            return !isExport && isNumber
                ? <div style={{ textAlign: 'right' }}>{valueFormat}</div>
                : value;
        };
    };

    getHeader(name: string): any {
        let header: string = (this.config[name] || [])[0] || null;

        if (!header) {
            const kennzahl: any = ((this.props.data || {})[IDs.ENT_KENNZAHLEN_DEFINTION] || [])
                .find((item: any) => item.kuerzel === name) || {};
            header = `${kennzahl.name || name}`;
            header += kennzahl.einheit ? ` [${kennzahl.einheit}]` : '';
        }

        return { Header: header, HeaderText: header, ...((this.config[name] || [])[2] && { width: this.config[name][2] }) };
    }

    init(): void {
        const gewerk_tids: number[] = [];

        (this.props.data[IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL] || []).forEach((kennzahl: any) => {
            const betrieb: string = kennzahl.betrieb || null;
            const gewerk: string = kennzahl.branchen_gewerke_tid || null;
            const gewerk_tid: number = kennzahl.branchen_gewerke_tid_orig || null;
            const jahr: number = kennzahl.jahr || null;
            const key: string = betrieb && jahr ? `${betrieb}|${jahr}` : null;
            const kuerzel: string = kennzahl.kuerzel || null;

            if (gewerk_tids.indexOf(gewerk_tid) === -1) {
                this.data[gewerk_tid] = {};
                this.columns[gewerk_tid] = [];
                gewerk_tids.push(gewerk_tid);
            }

            if (this.columns[gewerk_tid].indexOf(kuerzel) === -1) {
                this.columns[gewerk_tid].push(kuerzel);
            }

            if (key && !this.data[gewerk_tid][key]) {
                this.data[gewerk_tid][key] = { gewerk, betrieb, jahr };
            }

            if (this.data[gewerk_tid][key]) {
                this.data[gewerk_tid][key][kuerzel] = kennzahl.wert || null;
            }
        });
        this.gewerke = (this.props.data[IDs.ENT_BRANCHEN_GEWERKE] || [])
            .filter((element: any) => gewerk_tids.indexOf(element.tid) !== -1)
            .sort((a: any, b: any) => (a.name || '') < (b.name || '') ? -1 : 1);

        if (this.gewerke.length) {
            this.setState({ gewerk: this.gewerke[0].tid });
        }
    }

    render(): JSX.Element {
        return (
            <WTable
                entity={null}
                data={this.state.data}
                columns={this.state.columns}
                customClass='Custom-ETA'
                externalHeaderElements={this.renderHeaderElements()}
                onAction={() => {}}
                showPagination
                pageSize={25}
            />
        );
    }

    renderHeaderElements(): JSX.Element[] {
        return [
            <div style={{ fontSize: 12, margin: 'auto', marginLeft: 5 }}>
                <label
                    style={{ fontWeight: 'bold', marginLeft: 5, cursor: 'pointer' }}
                    htmlFor='gewerk'
                >
                    Gewerk:
                </label>
                <select
                    id='gewerk'
                    style={{ margin: '0 5px', cursor: 'pointer' }}
                    value={this.state.gewerk}
                    onChange={(event: any) => this.setState({ gewerk: +event.target.value || 0 })}
                >
                    {!this.gewerke.length &&
                        <option>{`<keine Daten vorhanden>`}</option>
                    }
                    {this.gewerke.length > 1 &&
                        <option key={`gewerk-`} value={0}>
                            Alle Gewerke
                        </option>
                    }
                    {this.gewerke.map((gewerk: any, index: number) =>
                        <option key={`gewerk-${index}`} value={gewerk.tid}>
                            {gewerk.name || null}
                        </option>
                    )}
                </select>
            </div>
        ];
    }

    setColumns(): void {
        if (typeof this.state.gewerk === 'number' && (this.columns[this.state.gewerk] || this.gewerke.length)) {
            const keys: string[] = Object.keys(this.config);
            let data: string[] = [];

            if (this.state.gewerk === 0) {
                Object.keys(this.columns).forEach((gewerk: string) =>
                    this.columns[gewerk].forEach((key: string) => {
                        if (data.indexOf(key) === -1) {
                            data.push(key);
                        }
                    })
                );
            } else {
                data = this.columns[this.state.gewerk];
            }
            const columns: any[] = [
                { accessor: 'lfd', id: 'lfd', Cell: this.getCellInfo('gewerk'), ...this.getHeader('lfd') },
                { accessor: 'gewerk', id: 'gewerk', Cell: this.getCellInfo('gewerk'), ...this.getHeader('gewerk') },
                {
                    accessor: 'betrieb', id: 'betrieb', Cell: this.getCellInfo('gewerk'), ...this.getHeader('betrieb'), className: 'sticky',
                    headerClassName: 'sticky'
                },
                { accessor: 'jahr', id: 'jahr', Cell: this.getCellInfo('gewerk'), ...this.getHeader('jahr') },
                ...data.map((name: string) => {
                    return { accessor: name, id: name, Cell: this.getCellInfo(name), ...this.getHeader(name) };
                })
            ];
            columns.sort((a: any, b: any) => {
                const aIndex: number = keys.indexOf(a.id);
                const bIndex: number = keys.indexOf(b.id);
                return (aIndex !== -1 ? aIndex : keys.length) - (bIndex !== -1 ? bIndex : keys.length);
            })
            this.setState({ columns }, this.setData);
        }
    }

    setData(): void {
        if (typeof this.state.gewerk === 'number' && (this.data[this.state.gewerk] || this.gewerke.length)) {
            let data: any = {};

            if (this.state.gewerk === 0) {
                Object.keys(this.data).forEach((gewerk: string) =>
                    Object.keys(this.data[gewerk]).forEach((key: string) => {
                        data[key] = this.data[gewerk][key];
                    })
                );
            } else {
                data = this.data[this.state.gewerk];
            }
            this.setState({ data: Object.keys(data).sort().map((key: string, index: number) => {
                return { lfd: index + 1, ...data[key] };
            })});
        }
    }
}
